"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfChapterServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class PdfChapterService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.selectedChapters = new Set();
        this.showChapterSelection = false;
    }
    toggleChapterSelection(index, chapters) {
        if (this.selectedChapters.has(index)) {
            this.selectedChapters.delete(index);
        }
        else {
            this.selectedChapters.add(index);
        }
        // Trigger reactivity by creating new Set
        this.selectedChapters = new Set(this.selectedChapters);
    }
    selectAllChapters(chapters) {
        this.selectedChapters = new Set(chapters.map((_, index) => index));
    }
    deselectAllChapters() {
        this.selectedChapters = new Set();
    }
    getSelectedChaptersList(chapters) {
        return Array.from(this.selectedChapters)
            .map(index => chapters[index])
            .filter(chapter => chapter !== undefined);
    }
    resetChapterSelection() {
        this.selectedChapters = new Set();
        this.showChapterSelection = false;
    }
    setShowChapterSelection(show) {
        this.showChapterSelection = show;
    }
    getTotalPagesFromChapters(chapters) {
        if (chapters.length === 0)
            return 0;
        return Math.max(...chapters.map(chapter => chapter.endPage));
    }
    getChapterByPageNumber(chapters, pageNumber) {
        return chapters.find(chapter => pageNumber >= chapter.startPage && pageNumber <= chapter.endPage);
    }
    validateChapterPageRanges(chapters) {
        if (chapters.length === 0)
            return true;
        // Sort chapters by start page
        const sortedChapters = [...chapters].sort((a, b) => a.startPage - b.startPage);
        for (let i = 0; i < sortedChapters.length; i++) {
            const chapter = sortedChapters[i];
            // Check if start page is less than or equal to end page
            if (chapter.startPage > chapter.endPage) {
                return false;
            }
            // Check for overlaps with next chapter
            if (i < sortedChapters.length - 1) {
                const nextChapter = sortedChapters[i + 1];
                if (chapter.endPage >= nextChapter.startPage) {
                    return false;
                }
            }
        }
        return true;
    }
}
exports.PdfChapterServiceInstance = PdfChapterService;
exports.default = PdfChapterService.getSingleton();
